import * as React from 'react'
import Autocomplete from '@mui/material/Autocomplete'
import {useEffect} from 'react'
import * as bancas from '../redux/reducers'
import * as filter from '../../../redux-commons/FilterRedux/filterRedux'
import {useDispatch} from 'react-redux'
import {CustomDateInputBancas} from './DateTimePickerBanCas'
import {FormControl, InputAdornment, styled} from '@mui/material'
import BrandingWatermarkIcon from '@mui/icons-material/BrandingWatermark'
import CardMembershipIcon from '@mui/icons-material/CardMembership'

type Props = {
  id: string
  options: any[]
  label: string
  defaultValue: string
  objectSelected?: number
  tabName?: string
  formName?: string
  required?: boolean
  validateField?: boolean
  autoCompleteReadOnly?: boolean
  handleValueChanged?: (value: string) => void
}

const AutoCompleteInput = styled(CustomDateInputBancas)(({theme}) => ({
  '& .MuiAutocomplete-input': {
    padding: '12.5px 4px 12.5px 14px !important',
    backgroundColor: 'inherit',
    fontWeight: '500',
  },
  '& .MuiAutocomplete-inputRoot': {
    padding: '1px !important',
    paddingLeft: '14px',
  },
  '& .MuiAutocomplete-endAdornment': {
    top: 'calc(50% - 12px)',
  },
}))

export const AutoCompleteBanCas: React.FC<Props> = ({
  id,
  options,
  label,
  autoCompleteReadOnly,
  defaultValue,
  tabName,
  formName,
  objectSelected,
  validateField,
  required,
  handleValueChanged
}) => {
  const [value, setValue] = React.useState<string | null>(options[0]?.value)
  const [inputValue, setInputValue] = React.useState('')
  const dispatch = useDispatch()

  const handleSaveDataRedux = (value: string) => {
    if(handleValueChanged) handleValueChanged(value)
    if (formName && !formName.toLocaleLowerCase().includes('filter')) {
      let data = {
        key: id ? id : '',
        value: value ? value : '',
        tab: tabName ? tabName : '',
        form: formName,
        objectSelected: objectSelected ? objectSelected : 0,
      }
      dispatch(bancas.actions.addBancasInfors(data))
    } else if (formName && formName.toLocaleLowerCase().includes('filter')) {
      let data = {
        field: id ? id : '',
        value: value,
        filterForm: formName,
      }
      dispatch(filter.actions.updateFilterInfo(data))
    }
  }

  const handleChangeValue = (value: string | null) => {
    if (value) {
      setValue(value)
      handleSaveDataRedux(JSON.parse(JSON.stringify(value)).value)
    }
  }

  const IconInput = () => (
    <>
      {id == 'carBrand' && <BrandingWatermarkIcon color='disabled' />}
      {id == 'carCompany' && <CardMembershipIcon color='disabled' />}
    </>
  )

  useEffect(() => {
    if (defaultValue) {
      let test = ''
      if (options.length > 0) test = options.find((o: any) => o.value === defaultValue)
      if (test) {
        setValue(test)
      }
    }
  }, [defaultValue])

  return (
    <div className='field-wrapper'>
      <FormControl error={validateField} sx={{width: '100%'}}>
        <Autocomplete
          id={id}
          options={options}
          getOptionLabel={(option: any) => option.label || ''}
          disabled={autoCompleteReadOnly}
          readOnly={autoCompleteReadOnly}
          inputValue={inputValue}
          onInputChange={(event, newInputValue) => {
            setInputValue(newInputValue)
          }}
          onChange={(event: any, newValue: string | null) => {
            handleChangeValue(newValue)
          }}
          value={value}
          renderInput={(params) => (
            <AutoCompleteInput
              {...params}
              label={label}
              InputLabelProps={{required: required}}
              error={validateField}
              InputProps={{
                ...params.InputProps,
                startAdornment: (
                  <InputAdornment position='start'>
                    <IconInput />
                  </InputAdornment>
                ),
              }}
            />
          )}
        />
      </FormControl>
    </div>
  )
}
